import { render } from "./TileShapeSelect.vue?vue&type=template&id=efe43ad6&scoped=true"
import script from "./TileShapeSelect.vue?vue&type=script&lang=js"
export * from "./TileShapeSelect.vue?vue&type=script&lang=js"

import "./TileShapeSelect.vue?vue&type=style&index=0&id=efe43ad6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe43ad6"]])

export default __exports__